import propTypes from "prop-types";
import React, { useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { ReactComponent as ClearIcon } from "../../assets/icons/cancel.svg";
import SearchIcon from "../../assets/icons/search-no-bg.svg";

function BackendTableSearch({
  // dataKey,
  // dataForFilter,
  placeholder,
  searchValue,
  setSearchValue,
  setCurrentPage,
}) {
  const [showInput, setShowInput] = useState(false);
  // const placeholder = "Search by learning assests";
  const [keyCodde] = useState("");

  const outSideClickHandler = () => {
    setShowInput(false);
  };

  let spliitedValue = searchValue?.split(" ");

  const handleChange = (e) => {
    if (searchValue === "" && keyCodde === 32) {
      return;
    }

    if (
      spliitedValue?.length > 1 &&
      spliitedValue[spliitedValue?.length - 1] === ""
    ) {
      if (keyCodde === 32) {
        return searchValue;
      } else {
        setSearchValue(e.target.value);
      }
    } else {
      setSearchValue(e.target.value);
    }

    if (setCurrentPage) {
      setCurrentPage(1);
    }
  };

  //   const handleKeyDown = (event) => {
  //     setKeyCode(event.keyCode);
  //     if (event.keyCode === 13) {
  //       refetch();
  //     }
  //   };

  const clearTextHandler = () => {
    setSearchValue("");
    if (setCurrentPage) {
      setCurrentPage(1);
    }
  };

  const handleSubmit = () => {
    setShowInput(true);
  };

  // const dataForSearchBox = dataForFilter?.filter((data) => {
  //   return spliitedValue?.some((item) => {
  //     if (data[dataKey]?.toLowerCase().includes(item.toLowerCase())) {
  //       return data;
  //     }
  //   });
  // });

  return (
    <OutsideClickHandler onOutsideClick={outSideClickHandler}>
      <div>
        <div
          className={`z-50 ${
            showInput ? "min-w-[26rem] " : ""
          } rounded-2xl shadow-outer flex p-[1rem]  relative bg-white `}
        >
          {showInput && (
            <div className={`${showInput ? "w-full" : ""} flex  items-center`}>
              <input
                type="text"
                name="search"
                value={searchValue}
                placeholder={placeholder}
                onChange={(e) => handleChange(e)}
                autoFocus
                // onKeyDown={handleKeyDown}
                className="w-full text-secondary-600 font-normal font-ibm focus:outline-none"
                autoComplete="off"
              />
              <ClearIcon
                className="mr-5 cursor-pointer"
                onClick={clearTextHandler}
              />
            </div>
          )}
          <div className="h-5 w-5 flex items-center justify-end">
            <img
              src={SearchIcon}
              className="cursor-pointer"
              alt="search"
              onClick={() => handleSubmit()}
            />
          </div>
        </div>
        {/* {searchValue[0]?.length > 0 && showInput && (
          <div className="ml-5">
            <ul className="h-auto pt-2 w-96 border-2 border-solid border-gray-200 rounded-lg shadow-lg absolute z-50 bg-white overflow-y-scroll scrollbar scrollbar-thumb-secondary-700 scrollbar-thin scrollbar-thumb-rounded  max-h-[10rem]">
              {dataForSearchBox?.length > 0
                ? dataForSearchBox.map((data, ind) => (
                    <SearchDropBox
                      name={data[dataKey]}
                      setInputValue={setSearchValue}
                      inputValue={searchValue}
                      key={ind}
                      data={dataForFilter}
                    />
                  ))
                : "No Record Found"}
            </ul>
          </div>
        )} */}
      </div>
    </OutsideClickHandler>
  );
}
BackendTableSearch.propTypes = {
  dataForFilter: propTypes.array,
  dataKey: propTypes.string,
  placeholder: propTypes.string,
  searchValue: propTypes.string,
  setSearchValue: propTypes.func,
  setCurrentPage: propTypes.func,
};
export default BackendTableSearch;
